import type { Role } from '../types';

/**
 * Where a role lands after signing in.
 *
 * Deliberately the single source of truth: this used to be duplicated in LoginPage and App, and
 * when the Dealer role was added only one copy was updated — so dealers were redirected to the
 * staff dashboard and met a 403. Any new role only has to be handled here.
 */
export function homePathForRole(role: Role | undefined): string {
  switch (role) {
    case 'Investor':
      return '/portal';
    case 'Dealer':
      return '/dealer-portal';
    default:
      return '/dashboard';
  }
}
